//native
import React from 'react';
import Cookies from 'universal-cookie';
// import TagManager from 'react-gtm-module';

//components
import Arquivo from '../childrens/arquivo/.mixins/Main';
import Main from '../childrens/main/.mixins/Main';
import Alerta from "../../../../../util/snackbars/.mixins/";

//controllers
import Config from '../../../../../../controllers/config';
import c_protocoloLogistico from '../../../../../../controllers/protocoloLogistico';
import { AuthContext } from '../../../../../../contexts/AuthContext';

export default class Politicas extends React.Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.permissions = {};

        this.state = {
            nomeArquivo: null,
            tipo: null,
            data: null,
            file: null,
            isLoading: false,
            isError: false,
        };

        this.handlerArquivo = this.handlerArquivo.bind(this);
    };

    componentWillMount() {
        this.permissions = this.context.user.permissions;
    }
    
    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:protocolo-logistico',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-protocolo-logistico',
        //     }
        // });
    }

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    handlerArquivo = async (e) => {
        if (e.target.files.length > 0) {
            var filename = e.target.files[0].name;
            var tipo = e.target.files[0].type;
            var base64 = await this.toBase64(e.target.files[0]);
            var dataType = base64.split(';base64,')[1];
            this.setState({
                nomeArquivo:filename, 
                tipo: tipo,
                data: dataType
            });
            this.valTamanhoArquivo();
            this.valExtensaoArquivo();
            this.enviar();
        }
    }

    valTamanhoArquivo = () => {
        var file = document.querySelector('input[type="file"]').files[0];
        var tamanho = this.formatBytes(file.size);
        if (tamanho.size > 5.00) {
            document.querySelector('#tamanho').style.color = "red";
        } else {
            document.querySelector('#tamanho').style.color = "rgba(0, 0, 0, 0.54)";
        }
    };

    valExtensaoArquivo = () => {
        var file = document.querySelector('input[type="file"]').files[0];
        var length = file.name.split(".").length;
        var extension = file.name.split(".")[length-1];
        if (extension.toLowerCase() === 'pdf') {
            document.querySelector('#extensao').style.color = "rgba(0, 0, 0, 0.54)";
        } else {
            document.querySelector('#extensao').style.color = "red";
        }
    };

    formatBytes = (bytes) => {
        var kb = 1024;
        var ndx = Math.floor( Math.log(bytes) / Math.log(kb) );
        var fileSizeTypes = ["bytes", "kb", "mb", "gb", "tb", "pb", "eb", "zb", "yb"];
        
        return {
            size: +(bytes / kb / kb).toFixed(2),
            type: fileSizeTypes[ndx]
        };
    }

    load = async () => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        //carrega nome do arquivo
        const nomeFile = "sample.pdf";
        const tipoFile = "application/pdf";

        try {
            var result = await c_protocoloLogistico.get(token);
            var decodeBody = JSON.parse(result.res.body);
            if (result.res.statusCode == 200) {
                this.setState({
                    nomeArquivo: nomeFile,
                    tipo: tipoFile,
                    data: decodeBody.file,
                    isLoading: false,
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:protocolo-logistico',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:arquivo`,
                //     }
                // });
            } else {
                throw new Error("Ocorreu um erro ao fazer retorno do arquivo!");
            }
        } catch (error) {
            this.child.current.retorno('Ocorreu um erro ao fazer retorno do arquivo!','error');
            var errorString = "Ocorreu um erro ao fazer retorno do arquivo!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:protocolo-logistico',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
        
    };

    receivedText = () => {
        showResult(fr, "Text");

        fr = new FileReader();
        fr.onload = receivedBinary;
        fr.readAsBinaryString(file);
    }

    enviar = async () => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            var file = document.querySelector('input[type="file"]').files[0];
            var formData = new FormData();
            var base64 = await this.toBase64(file);
            formData.append("file", base64.split(",")[1]);
            this.setState({isLoading: true});
            var result = await c_protocoloLogistico.post(token,formData);
            if (result.status === 200) {
                // this.setState({isLoading: false});
                // this.child.current.retorno('Arquivo alterado!','success');
                
                // TagManager.dataLayer({
                //     dataLayer: {
                //         event: 'event',
                //         eventCategory: 'tokstok:fornecedores:protocolo-logistico',
                //         eventAction: 'callback',
                //         eventLabel: `sucesso:${file.name}`,
                //     }
                // });
                window.location.reload();
            } else {
                throw new Error("Ocorreu um erro ao fazer upload do arquivo!");
            }
        } catch (error) {
            console.log(error.message)
            this.child.current.retorno('Ocorreu um erro ao fazer upload do arquivo!','error');
            this.setState({isLoading: false});

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:protocolo-logistico',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
    };

    render = () => {
        return (
            <div>
                {this.permissions["manter-protocolo-logistico"] &&
                    <Arquivo {...this}/>
                }
                <br/>
                <Main {...this}/>
                <Alerta ref={this.child}/>
            </div>
        );
    };

};